import { useQuery } from '@apollo/client';

import { POS_CONFIG_QUERY } from '@/shared/graphql/system.gql';

interface PosConfigResponse {
  posConfig: { demo_mode_enabled: boolean };
}

/** Purely cosmetic — gates the "+ PLUS" sidebar badge. No access-control implications. */
export function useDemoMode(): boolean {
  const { data } = useQuery<PosConfigResponse>(POS_CONFIG_QUERY, {
    fetchPolicy: 'cache-and-network',
  });
  return data?.posConfig.demo_mode_enabled ?? false;
}
